import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const MoreLikeThisCarouselBackgroundContainer = styled.div`
  max-width: 100vw !important;
  background-color: ${palette.white};
`;

export const MoreLikeThisCarouselContainer = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 5rem 2.8rem;
  display: grid;
  grid-row-gap: 2rem;

  .article-slide-container .article-slide-title {
    font-size: 1.5rem;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 3rem 0 2rem;
  }
`;
